// extracted by mini-css-extract-plugin
module.exports =  {"main":"OneColumn-module__main___o6Jfr"};